import type { AppSemanticTokens } from './semantic.model';

export const colorScheme: AppSemanticTokens['colorScheme'] = {
	light: {
		surface: {
			0: '{neutral.white}',
			50: '{gray.50}',
			100: '{gray.100}',
			200: '{gray.200}',
			300: '{gray.300}',
			400: '{gray.400}',
			500: '{gray.500}',
			600: '{gray.600}',
			700: '{gray.700}',
			800: '{gray.800}',
			900: '{gray.900}',
			950: '{gray.950}',
			960: '{gray.960}',
		},
		primary: {
			color: '{primary.400}',
			contrastColor: '{neutral.white}',
			hoverColor: '{primary.600}',
			activeColor: '{primary.700}',
		},
		highlight: {
			background: '{primary.50}',
			focusBackground: '{primary.100}',
			color: '{primary.700}',
			focusColor: '{primary.800}',
		},
		mask: {
			background: '#00000066',
			color: '{surface.200}',
		},
		formField: {
			background: '{surface.0}',
			disabledBackground: '{surface.100}',
			filledBackground: '{surface.50}',
			filledHoverBackground: '{surface.50}',
			filledFocusBackground: '{surface.50}',
			borderColor: '{surface.200}',
			hoverBorderColor: '{surface.400}',
			focusBorderColor: '{primary.300}',
			invalidBorderColor: '#f87171',
			color: '{neutral.950}',
			disabledColor: '{text.color}',
			placeholderColor: '{surface.400}',
			invalidPlaceholderColor: '{surface.400}',
			floatLabelColor: '{surface.500}',
			floatLabelFocusColor: '{surface.500}',
			floatLabelInvalidColor: '{form.field.invalid.placeholder.color}',
			iconColor: '{surface.400}',
			shadow: '0 1px 2px 0 rgba(0, 0, 0, 0.06), 0 1px 3px 0 rgba(0, 0, 0, 0.1)',
			invalidBackground: '{red.50}',
		},
		feedback: {
			info: {
				background: '#eff6fff2',
				borderColor: '#bfdbfe',
				color: '#2563eb',
				hoverBackground: '#dbeafe',
			},
			success: {
				background: '#f0fdf4f2',
				borderColor: '#bbf7d0',
				color: '#16a34a',
				hoverBackground: '#dcfce7',
				strongColor: '#15803d',
			},
			warn: {
				background: '#fefce8f2',
				borderColor: '#fef08a',
				color: '#ca8a04',
				hoverBackground: '#fef9c3',
				strongColor: '#854d0e',
				accentColor: '#f97316',
			},
			danger: {
				background: '#fef2f2f2',
				borderColor: '#fecaca',
				color: '#dc2626',
				hoverBackground: '#fee2e2',
				strongColor: '#b91c1c',
			},
			help: {
				color: '#a855f7',
				hoverColor: '#9333ea',
				activeColor: '#7e22ce',
			},
		},
		named: {
			platinum: '#e7e7e7',
			ink: '#000',
			footer: {
				background: '#fbfbfb',
				borderColor: '#dde3e5',
			},
			tag: {
				primaryBackground: '#F7F7F7',
			},
			image: {
				toolbarBackground: 'rgba(255, 255, 255, 0.1)',
				toolbarBorderColor: 'rgba(255, 255, 255, 0.2)',
				actionHoverBackground: 'rgba(255, 255, 255, 0.1)',
			},
			questionnaire: {
				statusSegmentColor: '#4a5666',
				selectedProgressTrackBackground: 'rgba(255, 255, 255, 0.14)',
				progressValueColor: '#161515',
			},
			activityDataValidation: {
				defaultBackground: 'rgba(228, 231, 236, 0.3)',
			},
			idleSessionModal: {
				titleColor: 'oklch(20.8% 0.042 265.755)',
				textColor: 'oklch(44.6% 0.043 257.281)',
			},
			inspectionStepBlockedView: {
				overlayBackground: 'rgba(255, 255, 255, 0.9)',
			},
		},
		text: {
			color: '{neutral.960}',
			hoverColor: '{primary.600}',
			mutedColor: '{surface.300}',
			hoverMutedColor: '{surface.400}',
		},
		content: {
			background: '{surface.0}',
			hoverBackground: '{surface.100}',
			borderColor: '{surface.200}',
			color: '{text.color}',
			hoverColor: '{text.hover.color}',
			subtleBackground: '#f9fafb',
		},
		overlay: {
			select: {
				background: '{surface.0}',
				borderColor: '{surface.200}',
				color: '{text.color}',
			},
			popover: {
				background: '{surface.0}',
				borderColor: '{surface.200}',
				color: '{text.color}',
			},
			modal: {
				background: '{surface.0}',
				borderColor: '{surface.200}',
				color: '{text.color}',
				bodyColor: '#4b5563',
			},
		},
		list: {
			option: {
				focusBackground: '{surface.100}',
				selectedBackground: '{highlight.background}',
				selectedFocusBackground: '{highlight.focus.background}',
				color: '{text.color}',
				focusColor: '{text.hover.color}',
				selectedColor: '{highlight.color}',
				selectedFocusColor: '{highlight.focus.color}',
				icon: {
					color: '{surface.400}',
					focusColor: '{surface.500}',
				},
			},
			optionGroup: {
				background: '#00000000',
				color: '{text.muted.color}',
			},
		},
		navigation: {
			item: {
				focusBackground: '{surface.100}',
				activeBackground: '{surface.100}',
				color: '{text.color}',
				focusColor: '{text.hover.color}',
				activeColor: '{text.hover.color}',
				icon: {
					color: '{surface.400}',
					focusColor: '{surface.500}',
					activeColor: '{surface.500}',
				},
			},
			submenuLabel: {
				color: '{text.muted.color}',
			},
			submenuIcon: {
				color: '{surface.400}',
				focusColor: '{surface.500}',
				activeColor: '{surface.500}',
			},
		},
	},
};
